"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = exports.CSS = void 0;
const mithril_1 = require("../../mithril");
const scale_1 = require("../animation/scale");
const spin_1 = require("../animation/spin");
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-Spinner',
    isExiting: 'c-Spinner--is-exiting',
    circle: 'c-Spinner__circle',
    buttonSize: 'c-Spinner--big'
};
const FADE_TIME = 150;
const SPIN_TIME = 1100;
const CONTAINER_SIZE = theme_1.DefaultTheme.space(6);
const CIRCLE_SIZE = theme_1.DefaultTheme.space(4);
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: CONTAINER_SIZE,
        height: CONTAINER_SIZE,
        'align-self': 'center',
        animation: `${scale_1.SCALE.IN} ${FADE_TIME}ms`
    },
    [exports.CSS.circle]: {
        height: CIRCLE_SIZE,
        width: CIRCLE_SIZE,
        margin: '2px',
        border: `2px solid ${(0, theme_1.rgba)(theme_palette_1.GOOGLE_BLUE)}`,
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: `${spin_1.SPIN} ${SPIN_TIME}ms infinite linear`
    },
    [exports.CSS.buttonSize]: {
        width: theme_1.DefaultTheme.space(8)
    },
    ['mdl-button .' + exports.CSS.container]: {
        margin: 'auto'
    }
});
function view(className = '') {
    return (0, mithril_1.m)('div', { className: `${exports.CSS.container} ${className}` }, [
        (0, mithril_1.m)('div', { className: exports.CSS.circle })
    ]);
}
exports.Spinner = { view, CSS: exports.CSS };
//# sourceMappingURL=spinner.js.map